import { App, URLOpenListenerEvent } from '@capacitor/app';
import { useIonRouter } from '@ionic/react';
import React, { useEffect } from 'react';

const deepLinkUrl = "react://";

const AppUrlListener: React.FC<any> = () =>
{
    const router = useIonRouter();

    // console.log("===== DeepLink/AppUrlListener: render");

    function handleDeepLink(event: URLOpenListenerEvent)
    {
        console.log("===== handleDeepLink", event);
        try {
            const url = event.url;
            console.log("===== handleDeepLink: url", url);
            if (url.includes(deepLinkUrl)) {
                const route = url.split(deepLinkUrl).pop();
                console.log("===== handleDeepLink: route", route);
                if (route) router?.push(route);
            }
        }
        catch (error) { 
            console.log("===== handleDeepLink: error", error);
        }
    }

    useEffect(() =>
    {
        App.addListener('appUrlOpen', handleDeepLink);

        return () =>
        {
            App.removeAllListeners();
        };
    }, []);

    return null;
};

export default AppUrlListener;